import SearchText from './SearchText'

export default SearchText
// eslint-disable-next-line import/export
export * from './SearchText'
